import {
  WorkspaceDialogService,
  type DialogComponentProps,
  type GLOBAL_DIALOG_SCHEMA,
} from '@affine/core/modules/dialogs';
import { useEffect, useMemo, useState } from 'react';
import * as styles from './index.css';
import { useI18n } from '@affine/i18n';
import IconFont from '@ys/repo-ui/base/IconFont';
import { useService } from '@toeverything/infra';
import { GlobalContextService } from '@affine/core/modules/global-context';
import { useNavigateHelper } from '@affine/core/components/hooks/use-navigate-helper';
import type { SettingTab } from '@affine/core/modules/dialogs/constant';

export const UpgradePlanDialog = ({
  close,
  localStorageKey,
  imageUrl,
  title,
  subTitle,
  buttons,
  modalStyles,
  closeButtonAction,
  userId,
}: DialogComponentProps<GLOBAL_DIALOG_SCHEMA['upgrade-plan']>) => {
  const t = useI18n();
  const [isShowUpgradePlan, setIsShowUpgradePlan] = useState(true);
  const globalContextService = useService(GlobalContextService);
  const currentWorkspaceId =
    globalContextService.globalContext.workspaceId.get();
  // 使用路由导航跳转到设置页面
  const { jumpToWorkspaceSettings } = useNavigateHelper();
  const onClose = () => {
    setIsShowUpgradePlan(false);
    close();
    // if (localStorageKey) {
    //   localStorage.setItem(localStorageKey, 'true');
    // }
    // close();
  };
  const onClickReject = () => {
    setIsShowUpgradePlan(false);
    close();
    // if (localStorageKey) {
    //   localStorage.setItem(localStorageKey, 'true');
    // }
    // close();
  };

  const onClickButton = ({
    type,
    extraOptions,
  }: {
    type: string;
    extraOptions: { activeSettingTab?: string; pageUrl?: string } | null;
  }) => {
    if (type === 'closeModal') {
      setIsShowUpgradePlan(false);
      close();
    } else if (type === 'openSettingModal') {
      close();
      const { activeSettingTab } = extraOptions || {};
      if (currentWorkspaceId) {
        jumpToWorkspaceSettings(
          currentWorkspaceId,
          activeSettingTab ? (activeSettingTab as SettingTab) : 'plans'
        );
      }
    } else if (type === 'openPage') {
      close();
      const { pageUrl } = extraOptions || {};
      if (pageUrl) {
        window.location.href = pageUrl;
      }
    }
  };
  useEffect(() => {
    if (localStorageKey) {
      const catchActivity =
        localStorage.getItem(`hasShowActivity_${userId}`) || '';
      const hasShowActivity = catchActivity
        ? JSON.parse(catchActivity).hasShowActivity
        : [];
      localStorageKey.forEach(key => {
        if (!hasShowActivity.includes(key)) {
          hasShowActivity.push(key);
        }
      });
      localStorage.setItem(
        `hasShowActivity_${userId}`,
        JSON.stringify({ hasShowActivity })
      );
    }
  }, [localStorageKey]);

  return isShowUpgradePlan ? (
    <div className={styles.upgrade_wrapper}>
      <div className={`${styles.upgrade_content}`} style={modalStyles}>
        <div
          className={`${styles.upgrade_content_close}`}
          onClick={() => onClickButton(closeButtonAction)}
        >
          <img
            className={styles.upgrade_content_close_icon}
            src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/closeModalIcon.png"
            alt=""
          />
        </div>
        <img className={styles.upgrade_content_image} src={imageUrl} alt="" />
        <div className={styles.upgrade_content_title}>{title}</div>
        <div className={styles.upgrade_content_subtitle}>{subTitle}</div>
        <div className={styles.upgrade_content_button_wrapper}>
          {buttons.map((item, index) => {
            return (
              <div
                key={index}
                className={`${styles.upgrade_content_button_continue} ${buttons.length > 1 && index === 0 ? styles.firstButton : ''} ${buttons.length === 1 ? styles.onlyOneButton : ''}`}
                onClick={() =>
                  onClickButton({
                    type: item.action.type,
                    extraOptions: item.action.extraOptions,
                  })
                }
                style={item.styles}
              >
                {item.text}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  ) : null;
};
